import Vue from 'vue'

export default {
    getFooter(){
        return Vue.axios.get("/api/footer/find").then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    },
    updateFooter(parametros){
        return Vue.axios.put("api/footer/update", parametros).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    },
}
